let googleMapsScriptPromise = null;

const MAPS_SCRIPT_SELECTOR = 'script[src*="maps.googleapis.com/maps/api/js"]';

const mapsReady = () =>
  !!(window.google && window.google.maps && window.google.maps.Map);

const notifyVueGoogleMaps = () => {
  if (typeof window.vueGoogleMapsInit === "function") {
    window.vueGoogleMapsInit();
  }
};

const waitForMaps = () => {
  if (mapsReady()) return Promise.resolve();

  return new Promise((resolve, reject) => {
    let ticks = 0;
    const id = setInterval(() => {
      if (mapsReady()) {
        clearInterval(id);
        resolve();
        return;
      }
      if (++ticks > 100) {
        clearInterval(id);
        reject(new Error("Google Maps failed to load."));
      }
    }, 50);
  });
};

export function loadGoogleMapsScript(apiKey) {
  if (mapsReady()) {
    notifyVueGoogleMaps();
    return Promise.resolve();
  }

  if (!googleMapsScriptPromise) {
    googleMapsScriptPromise = new Promise((resolve, reject) => {
      const finish = () => {
        notifyVueGoogleMaps();
        resolve();
      };

      window.__rrGoogleMapsLoaded = finish;

      if (document.querySelector(MAPS_SCRIPT_SELECTOR)) {
        waitForMaps()
          .then(finish)
          .catch(reject);
        return;
      }

      const script = document.createElement("script");
      script.src =
        "https://maps.googleapis.com/maps/api/js?key=" +
        encodeURIComponent(apiKey) +
        "&loading=async&callback=__rrGoogleMapsLoaded";
      script.async = true;
      script.defer = true;
      script.setAttribute("data-cfasync", "false");
      script.onerror = () =>
        reject(new Error("Google Maps failed to load."));
      document.head.appendChild(script);
    });
  }

  return googleMapsScriptPromise;
}
